export const environment = {
  env: 'GCPPROD',
  production: true,
  extraDebugMode: false,
  S1Url: "https://api.sample.ipsos.com",
  fezeUrl: "https://fizzy.ipsos.com",
  natRepUrl: "https://natrep.ipsos.com",
  supplierUrl: "https://supplier.ipsos.com",
  fileConfigBasePath: "https://fizzy.ipsos.com/api/v1/FileConfiguration/",
  genPopUrl: "https://quotair.ipsos.com",
  s1FizzyAdminGroup: "Feasibility Admin"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts